import React from 'react';
import './HomePage.scss';
import HeroSection from '../../Components/HomePage/HeroSection/HeroSection';
import QuadImages from '../../Components/HomePage/QuadImages/QuadImages';
import RecentProjects from '../../Components/HomePage/RecentProjects/RecentProjects';
import ContentImage from '../../Components/HomePage/ContentImage/ContentImage';
import Services from '../../Components/HomePage/Services/Services';
import WebsiteFeatures from '../../Components/HomePage/WebsiteFeatures/WebsiteFeatures';

import { ReactComponent as SvgGradient } from '../../assets/img/svgGradient.svg';
import WebsiteDesignProcess from '../../Components/HomePage/WebsiteDesignProcess/WebsiteDesignProcess';
import LatestBlogs from '../../Components/HomePage/LatestBlogs/LatestBlogs';
import CostCalculatorRibbon from '../../Components/HomePage/CostCalculatorRibbon/CostCalculatorRibbon';
import Reviews from '../../Components/HomePage/Reviews/Reviews';
import ContactForm from '../../Components/HomePage/ContactForm/ContactForm';

export default function HomePage() {
  return (
    <main className='homepage'>
      <HeroSection />
      <QuadImages />
      <RecentProjects />
      <ContentImage />
      <Services />
      <WebsiteFeatures />
      <WebsiteDesignProcess />
      <LatestBlogs />
      <CostCalculatorRibbon />
      <Reviews />
      <ContactForm />
      <SvgGradient />
    </main>
  );
}
